export default {
  getAll(context) {
    return new Promise((resolve, reject) => {
      const productId = context.rootGetters.activeProductId;
      if (!productId) {
        context.commit("setModules", []);
        resolve();
        return;
      }
      window.axios
        .get(`/courses/modules/list/${productId}?limit=1000&status=published`)
        .then(response => {
          context.commit(
            "setModules",
            [...response.data.results].sort((a, b) => a.sort - b.sort)
          );
          resolve();
        })
        .catch(reject);
    });
  },
  search(context, params) {
    const queryString = new URLSearchParams(params).toString();
    return new Promise((resolve, reject) => {
      const productId = context.rootGetters.activeProductId || 171;
      window.axios
        .get(`/courses/modules/list/${productId}?${queryString}`)
        .then(response => {
          resolve(response.data);
        })
        .catch(reject);
    });
  },
  submodule_search(context, params) {
    const queryString = new URLSearchParams(params).toString();
    return new Promise((resolve, reject) => {
      const productId = context.rootGetters.activeProductId || 171;
      window.axios
        .get(`/modules/product/${productId}?${queryString}`)
        .then(response => {
          resolve(response.data);
        })
        .catch(reject);
    });
  },

  getDetails(context, id) {
    return new Promise((resolve, reject) => {
      window.axios
        .get(`/courses/modules/${id}`)
        .then(response => {
          context.commit("setModule", response.data);
          resolve(response.data);
        })
        .catch(reject);
    });
  },

  setProgress(context, data) {
    return new Promise((resolve, reject) => {
      window.axios
        .post("/reports/progress", data)
        .then(resolve)
        .catch(reject);
    });
  },

  // Fire-and-forget final progress save when the lesson route is being
  // unmounted (router-leave, beforeDestroy, tab close). We can't use axios
  // because the browser may cancel in-flight XHRs on unmount; fetch with
  // `keepalive: true` survives the unmount. We also can't use sendBeacon
  // because the backend requires the `Authorization: JWT <token>` header,
  // which Beacon does not allow setting. Payload is ~80 bytes — well below
  // the 64KB keepalive limit defined by the spec.
  flushProgressOnExit(context, { lesson_id, stopped_at }) {
    try {
      if (!lesson_id || typeof stopped_at !== "number" || stopped_at <= 0) {
        return;
      }
      const baseURL = window.axios && window.axios.defaults.baseURL;
      const authHeader =
        window.axios &&
        window.axios.defaults.headers &&
        window.axios.defaults.headers.common &&
        window.axios.defaults.headers.common.Authorization;
      if (!baseURL || !authHeader) return;

      fetch(`${baseURL}/reports/progress`, {
        method: "POST",
        keepalive: true,
        headers: {
          "Content-Type": "application/json",
          Authorization: authHeader
        },
        body: JSON.stringify({
          lesson_id,
          stopped_at,
          finished_at: false
        })
      }).catch(() => {
        // swallow — fire-and-forget; navigation must not block on this
      });
    } catch (e) {
      // never let the flush break navigation
    }
  },

  getLastLessons(context) {
    return new Promise((resolve, reject) => {
      const productId = context.rootGetters.activeProductId;
      window.axios
        .get(`/reports/last-lessons/${productId}`)
        .then(response => {
          context.commit("setLastLessons", response.data);
          resolve();
        })
        .catch(reject);
    });
  },
  getFAQ(context) {
    return new Promise((resolve, reject) => {
      const productId = context.rootGetters.activeProductId || 171;
      window.axios
        .get(`/modules/faq/u/list/${productId}?limit=999`)
        .then(response => {
          context.commit("setFaq", response.data.results);
          resolve(response.data);
        })
        .catch(reject);
    });
  },
  getGradeHistory(context, data) {
    return new Promise((resolve, reject) => {
      window.axios
        .get(`/exams/scores/list/${data.module_id}`)
        .then(response => {
          resolve(response.data);
        })
        .catch(reject);
    });
  },
  getCategories(context) {
    return new Promise((resolve, reject) => {
      const productId = context.rootGetters.activeProductId;
      window.axios
        .get(`/courses/categories/product/${productId}?limit=9999`)
        .then(response => {
          context.commit("setCategories", response.data.results);
          resolve(response.data.results);
        })
        .catch(reject);
    });
  }
};
